import React, { useEffect } from 'react';
import Console from '../../../lib/debug';
import BreadcrumbNav from '../../../view/nav/BreadcrumbNav';
import CONF from '../../../api/config';

const crumbs = [
    {
        displayString: 'Messaging',
        link: `/messaging`,
        editable: false
    }
];

const MessagingHubView = () => {
    Console.render('MessagingHubView');

    useEffect(() => {
        const navBar = document.getElementById('loading-nav-bar');
        navBar && navBar.classList.remove('loading-nav-bar');
    });

    const messagingLink = `${CONF.ADAPTER}/messaging?timestamp=${Date.now()}`;

    return (
        <div>
            <BreadcrumbNav crumbs={crumbs} />
            <div className="messaging-hub">
                <iframe
                    title="messagingHub"
                    frameBorder="none"
                    src={messagingLink}
                    allowFullScreen="true"
                    style={{
                        width: '100%',
                        height: '100%'
                    }}
                />
            </div>
        </div>
    );
};

export default MessagingHubView;
